<template>
  <q-dialog
    :model-value="modelValue"
    persistent
    @update:model-value="updateModelValue"
  >
    <q-card style="min-width: 420px; max-width: 90vw;">
      <q-card-section class="row items-center">
        <div class="text-h6">{{ $t('Edit storage item') }}</div>
        <q-space />
        <q-btn
          icon="close"
          flat
          round
          dense
          :disable="saving"
          @click="close"
        />
      </q-card-section>

      <q-card-section v-if="item">
        <div class="text-caption text-grey-7 q-mb-md">
          {{ $t('Id') }}: {{ item.id }}
          <span v-if="item.sku"> · {{ $t('Sku') }}: {{ item.sku }}</span>
        </div>

        <q-input
          v-model="serialNumber"
          outlined
          autofocus
          clearable
          :disable="saving"
          :label="$t('Serial number')"
          :hint="$t('Leave empty to clear the serial number')"
          @keyup.enter="submit"
        />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          flat
          :label="$t('Cancel')"
          :disable="saving"
          @click="close"
        />
        <q-btn
          color="primary"
          :label="$t('Save')"
          :loading="saving"
          @click="submit"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'StorageItemEditModal',
  emits: ['update:modelValue', 'save'],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      serialNumber: ''
    }
  },
  watch: {
    item: {
      immediate: true,
      handler (item) {
        this.serialNumber = item?.serialNumber || ''
      }
    }
  },
  methods: {
    updateModelValue (value) {
      this.$emit('update:modelValue', value)
    },
    close () {
      this.updateModelValue(false)
    },
    submit () {
      if (!this.item || this.saving) {
        return
      }

      const value = this.serialNumber == null
        ? ''
        : String(this.serialNumber).trim()

      this.$emit('save', {
        item: this.item,
        serialNumber: value || null
      })
    }
  }
}
</script>
